import React from "react";
import {ReactComponent as SucessBee} from "images/sucessfull.svg";

import ButtonPrimary from "shared/Button/ButtonPrimary";
interface SuccessModalProps {
  message?: string;
  onClick?: () => void;
}
export function SuccessModal({
  message = "Tu compra se ha realizado con éxito, ¡gracias por confiar en nosotros!",
  onClick,
}: SuccessModalProps) {
  return (
    <div className="p-6 text-center flex flex-col items-center space-y-6">
      <SucessBee className="w-40" />
      <h2 className="text-sm mb-4">{message}</h2>
      <ButtonPrimary
        onClick={() => {
          onClick?.();
          // navigate("/profile", {replace: true});
          window.location.href = "/profile";
        }}
      >
        Aceptar
      </ButtonPrimary>
    </div>
  );
}
